import { IAuPaginationData } from '@app/shared/ui-components/au-paginator/pagination-page.info';
import {
	IWorkOrder,
	IWorkOrderCostOfWorkFilterValues,
} from '../cmms-types/workorder-types';
import { ICMMSLocation } from '@app/pages/cmms/interfaces/cmms-global.interfaces';

export const periodTypes = ['DAY', 'WEEK', 'MONTH', 'YEAR'] as const;
export type PeriodType = (typeof periodTypes)[number];

export interface DatetimeIntervalFilterInput {
	offset: number;
	granularity: PeriodType;
	timezone: string; // Example: "Europe/Oslo"
}

export interface ICmmsWorkOrderQueryVariables
	extends IAuPaginationData,
		IWorkOrderCostOfWorkFilterValues {
	sortBy?: string;
	workOrderId?: string[];
	name?: string;
	description?: string;
	priority?: string[];
	status?: string[];
	createdBefore?: Date;
	createdAfter?: Date;
	updatedBefore?: Date;
	updatedAfter?: Date;
	deadlineBefore?: Date;
	deadlineAfter?: Date;
	isRepeatable?: boolean;
	category?: string[];
	assignee?: string[];
	locations?: string[];
	calendarAfter?: Date | string;
	calendarBefore?: Date | string;
	labels?: string[];
}

export interface IWorkOrderCreateResponse {
	createWorkOrder: {
		success: boolean;
		workOrder: IWorkOrder;
	};
}

export interface IWorkOrderUpdateSuccess {
	editWorkOrder: {
		success: boolean;
		workOrder: IWorkOrder;
	};
}

export interface IWorkOrderCopyVariables {
	locations?: Partial<ICMMSLocation>[];
	copyAssignee: boolean;
	copyApprover: boolean;
	copyDeadline: boolean;
	copyRoutine: boolean;
	copyPriority: boolean;
	copyCategory: boolean;
	copyChecklists: boolean;
	copyLabels: boolean;
}
